import axios from '@/plugins/axios'

export function getAreaSettings(params = {}) {
  return axios.get('area_setting', {
    params,
  })
}

export function updateAreaSettings(id, data) {
  return axios.put(`area_setting/${id}`, data)
}
